var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<img src=\"//ue.17173cdn.com/a/newgame/index/2017/v3.0.0/img/ico-gou.jpg\"\n     width=\"45\" height=\"45\">\n怀念成功，感谢您的热心参与！\n";
},"useData":true});